module.exports = __webpack_public_path__ + "img/電気回路_1_10_2.c7ef8918.png";